/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedFollowSearchBanner_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespFollowSearchBanner_user$ref: FragmentReference;
export type SbRespFollowSearchBanner_user = {|
  +$fragmentRefs: SbSharedFollowSearchBanner_user$ref,
  +$refType: SbRespFollowSearchBanner_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespFollowSearchBanner_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchBanner_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd5477c412d41bb2e02a37a8fa8aff305';
module.exports = node;
